// extracted by mini-css-extract-plugin
export default {"form":"RegisterForm_form__P6YFI","submitButton":"RegisterForm_submitButton__4hfvy","centered":"RegisterForm_centered__1Zt8F","requiredWarning":"RegisterForm_requiredWarning__13u4k"};